import Inputmask from 'inputmask';

const submitContactForm = function (formData, callback, message) {
  fetch('/actions/form/contact/send-email', {
    method: 'POST',
    headers: { accept: 'application/json' },
    body: formData,
  })
    .then((res) => res.json())
    .then((response) => {
      if (response.response.success === true) {
        callback(true);
      } else {
        console.log('Form error!');
        console.log(response);
        callback(false);
        message.innerHTML =
          'Det har oppstått en feil under sending av meldingen.';
        message.classList.add('active');
      }
    })
    .catch((error) => {
      callback(false);
      console.log(error);
      message.innerHTML =
        'Det har oppstått en feil under sending av meldingen.';
      message.classList.add('active');
    });
};

window.submitContactForm = submitContactForm;

export default () => {
  let fields = document.querySelectorAll('.field input');
  let forms = document.querySelectorAll('form[method=post]');

  var chekValues = function (field) {
    if (field === document.activeElement) {
      if (field.value.length > 0) {
        field.parentNode.classList.add('filled');
      } else {
        field.parentNode.classList.remove('filled');
      }
    }
  };

  Array.prototype.forEach.call(forms, function (form, index) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      grecaptcha.ready(function () {
        e.preventDefault();
        grecaptcha
          .execute('6Lf5w44pAAAAALC01difD9Kq8yj3Y_j4fqfa3F_l', {
            action: 'submit',
          })
          .then(function (token) {
            e.preventDefault();
            sendAnalyticsEvent('event_data', 'form', 'submit', form.id);
            var formData = new FormData(form);
            formData.append('captcha_token', token);
            var button = form.querySelector('input[type="submit"]');
            var message = form.querySelector('.form-message');
            var subject = form.querySelector('input[name="subject"]');
            button.classList.add('btn--loading');
            message.classList.remove('active');
            submitContactForm(
              formData,
              function (response) {
                console.log(response);
                button.classList.remove('btn--loading');
                if (response) {
                  // message.classList.add('active');
                  form.reset();
                  message.classList.remove('hidden');
                }
              },
              message
            );
          });
      });
    });
  });

  Array.prototype.forEach.call(fields, function (item, index) {
    if (item.type == 'checkbox') {
      item.addEventListener('change', function (e) {
        if (item.checked) {
          item.parentNode.classList.add('filled');
        } else {
          item.parentNode.classList.remove('filled');
        }
      });
    } else {
      item.addEventListener('keypress', function (e) {
        chekValues(item);
      });
      item.addEventListener('focus', function (e) {
        item.parentNode.classList.add('filled');
      });
      item.addEventListener('blur', function (e) {
        chekValues(item);
      });
    }
  });

  //masks (https://github.com/RobinHerbots/Inputmask)
  Inputmask().mask(fields);
};
